import React from 'react';
import PropTypes from 'prop-types';

function FilterItem({ filterTitle, children }) {
  return (
    <div className="ais-Panel">
      {filterTitle && <div className="ais-Panel-header">{filterTitle}</div>}
      <div className="ais-Panel-body">{children}</div>
    </div>
  );
}

FilterItem.propTypes = {
  children: PropTypes.node.isRequired,
  filterTitle: PropTypes.string,
};

FilterItem.defaultProps = {
  filterTitle: 'title',
};

export default FilterItem;
